// extracted by mini-css-extract-plugin
export default {"splashContainer":"Splash_splashContainer__pMXog","label":"Splash_label__IXtvO","logoFsfb":"Splash_logoFsfb__ylaRZ"};